/**
 * Corta uma coluna do Telão em páginas pelo que CABE (função pura, at-130).
 *
 * O telão não estima quantas placas cabem: ele mede cada item e distribui. É o que faz a mesma
 * tela funcionar num notebook e numa TV de 1080p sem número mágico.
 *
 * Itens são cabeçalhos de esteira ou conteúdo (placa, "Nenhum veículo"). Quando uma esteira
 * continua na página seguinte, a página começa com o cabeçalho de novo ("(cont.)"), e a altura
 * dele é reservada — senão a primeira placa da página ficaria sem dizer de que esteira é.
 */
export interface PaginaDaColuna {
  /** Índices dos itens da página, na ordem. */
  itens: number[];
  /** A página começa no meio de uma esteira: mostrar o cabeçalho dela com "(cont.)". */
  continuaDe: number | null;
}

export interface EntradaDaPaginacao {
  alturas: number[];
  ehCabecalho: boolean[];
  alturaCabecalhoCont: number;
  capacidade: number;
}

export function paginarPorAltura({ alturas, ehCabecalho, alturaCabecalhoCont, capacidade }: EntradaDaPaginacao): PaginaDaColuna[] {
  // Corpo ainda sem layout (capacidade 0 ou negativa): uma página com tudo, para não cortar nada.
  if (!(capacidade > 0)) return [{ itens: alturas.map((_, i) => i), continuaDe: null }];

  const paginas: PaginaDaColuna[] = [{ itens: [], continuaDe: null }];
  let usado = 0;
  let ultimoCabecalho: number | null = null;

  alturas.forEach((h, i) => {
    const atual = paginas[paginas.length - 1];
    if (usado + h > capacidade && atual.itens.length > 0) {
      const continua = !ehCabecalho[i] && ultimoCabecalho !== null ? ultimoCabecalho : null;
      paginas.push({ itens: [], continuaDe: continua });
      usado = continua !== null ? alturaCabecalhoCont : 0;
    }
    if (ehCabecalho[i]) ultimoCabecalho = i;
    // Um item maior que a capacidade ocupa a página sozinho (fica cortado, mas não trava a tela).
    paginas[paginas.length - 1].itens.push(i);
    usado += h;
  });

  // Cabeçalho que ficou sozinho no fim de uma página (a esteira começa na seguinte): move-o
  // para a página seguinte, onde estão as placas dele.
  for (let p = 0; p < paginas.length - 1; p++) {
    const pg = paginas[p];
    const ultimo = pg.itens[pg.itens.length - 1];
    const prox = paginas[p + 1];
    if (pg.itens.length > 1 && ehCabecalho[ultimo] && prox.continuaDe === ultimo) {
      pg.itens.pop();
      prox.itens.unshift(ultimo);
      prox.continuaDe = null;
    }
  }

  return paginas;
}
